<template>
  <div class="tag-tree" :style="`height:${treeHeight}px;`">
    <div class="tag-tree-add"><a-button type="primary" icon="plus" @click="addTagCategory">新增</a-button></div>
    <div class="tag-tree-head" :style="`maxHeight:${maxHeight ? maxHeight: 920}px;overflow: auto;`">
      <a-spin :spinning="loadingTree"/>
      <a-tree
        v-if="treeData.length > 0"
        show-line
        defaultExpandAll
        :tree-data="treeData"
        @select.self="onSelect"
        :selected-keys="defaultSelectKeys"
        :autoExpandParent="true"
        :replaceFields="{title: 'custom', children: 'childrens', key: 'id'}"
      >
        <template slot="custom" slot-scope="{ level, id, name, parentId, parentName, sortNo, number, description, isBaseTag }">
          <div class="tree-list">
            <span class="name" :title="name">{{ name }}</span>
            <div class="operation-btns">
              <a-dropdown :placement="'bottomCenter'">
                <a-menu style="width: 100px;text-align: center" slot="overlay" @click.self="e => treeHandleClick(e, { level, id, name, parentId, parentName, sortNo, number, description, isBaseTag })">
                  <a-menu-item :key="1">新增</a-menu-item>
                  <a-menu-item :key="2">编辑</a-menu-item>
<!--                  <a-menu-item :key="3" v-if="getUpElShow(id, parentId, level)">上移</a-menu-item>-->
<!--                  <a-menu-item :key="4" v-if="getDownElShow(id, parentId, level)">下移</a-menu-item>-->
                  <a-menu-item style="color: red;" :key="5">删除</a-menu-item>
                </a-menu>
                <a-icon type="ellipsis" />
              </a-dropdown>
            </div>
          </div>
        </template>
      </a-tree>
      <p class="noting-tag" v-else>暂无标签数据</p>
    </div>
    <add-tree-level ref="addTreeLevel" @done="addTagCategoryDone" />
  </div>
</template>

<script>
  import { getTagList as getTreeList, deleteTag } from 'api/request'
import addTreeLevel from './addTreeLevel'

export default {
  components: {
    addTreeLevel
  },
  data() {
    return {
      loadingTree: true,
      treeData: [],
      selectKey: undefined,
      cacheSelectKey: undefined,
      defaultSelectKeys: [],
      rightTableData: [],
      maxHeight: 'none',
      treeHeight: 0
    }
  },
  created() {
    this.getTreeList()
  },
  methods: {
    setHeight(innerHeight) {
      this.treeHeight = innerHeight - 150
      this.maxHeight = innerHeight - 198
    },
    /** 获取树形数据 */
    async getTreeList() {
      this.loadingTree = true
      this.treeData = []
      this.rightTableData = []
      this.$emit('getTagList', this.rightTableData)
      try {
        const data = await getTreeList({pageIndex: 1, pageSize: 99999})
        this.treeData = this.filterTreeData(data || [])
        this.defaultSelectKeys = this.cacheSelectKey ? [this.cacheSelectKey] : (this.treeData.length > 0 ? [this.treeData[0]['id']] : [])
        this.rightTableData = this.defaultSelectKeys.length > 0 ? this.getRightTableData(this.treeData, this.defaultSelectKeys[0]) : []
        this.$emit('getTagList', this.rightTableData)
        this.loadingTree = false
      } catch (err) {
        console.log(err)
        this.loadingTree = false
      }
    },
    /** 处理树形数据  添加属性 */
    filterTreeData(arr) {
      for (const item of arr) {
        item.scopedSlots = { title: 'custom' }
        if (item.childrens && item.childrens.length > 0) {
          this.filterTreeData(item.childrens)
        } else {
          item.childrens = []
        }
      }
      return arr
    },
    /** 树形数据根据当前id获取父节点id */
    finParentIdList (list, id) {
      if (!list || !id) {
        return []
      }
      var arr = []
      const findParent = (data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          var node = data[i]
          if (node.id === nodeId) {
            arr.unshift(nodeId)
            if (nodeId === list[0].id) {
              break
            }
            findParent(list, parentId)
            break
          } else {
            if (node.childrens) {
              findParent(node.childrens, nodeId, node.id)
            }
            continue
          }
        }
        return arr
      }
      return findParent(list, id)
    },
    /** 基础报价类目操作 */
    treeHandleClick({ key }, { level, id, name, parentId, parentName, sortNo, number, description, isBaseTag }) {
      // 新增
      if (key === 1) {
        this.cacheSelectKey = this.selectKey
        this.$refs.addTreeLevel.show(
          {
            sign: true,
            currentInfo: {
              id: undefined,
              name: undefined,
              number: undefined,
              isBaseTag: true,
              description: undefined
            },
            parentInfo: { id, name }
          }
        )
      }
      // 编辑
      if (key === 2) {
        this.cacheSelectKey = this.selectKey
        this.$refs.addTreeLevel.show(
          {
            sign: true,
            currentInfo: {
              id: id,
              name: name,
              number: number,
              description: description,
              isBaseTag: isBaseTag
            },
            parentInfo: { id: parentId, name: parentName },
          }
        )
      }
      // 上移
      if (key === 3) {
        const params = { key, id, name, sortNo: sortNo - 1 }
        this.sortQuoteItemBase(params)
      }
      // 下移
      if (key === 4) {
        const params = { key, id, name, sortNo: sortNo + 1 }
        this.sortQuoteItemBase(params)
      }
      // 删除
      if (key === 5) {
        const that = this
        that.$confirm('是否删除','是否删除该标签以及下级所有标签',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          deleteTag(id).then(res => {
            if (res) {
              that.$message.success('删除成功')
              that.cacheSelectKey = undefined
              that.getTreeList()
            } else {
              that.$message.error('删除失败')
            }
          })
        }).catch(() => {})
      }
    },
    /** 上移下移排序操作 */
    sortQuoteItemBase({ key, id, name, sortNo }) {
      const that = this
      const content = `是否${key === 3 ? '上移' : '下移'}"${name}"报价项`
      that.$confirm({
        title: `是否${key === 3 ? '上移' : '下移'}？`,
        content: content,
        onOk() {
          quoteItemBaseSort({ id, sortNo }).then(res => {
            if (res.code === 200) {
              that.$message.success('操作成功')
              that.cacheSelectKey = undefined
              that.getTreeList()
            } else {
              that.$message.error('操作失败')
            }
          }).catch(err => {
            that.$message.error(err.message)
          })
        },
        onCancel() {
        }
      })
    },
    /** 上移显示判断 */
    getUpElShow(id, parentId, level) {
      const toLineData = this.common.toLine(this.treeData, 'childrens')
      let temList = []
      if (level === 1) {
        temList = toLineData.filter(v => v.level === 1).map(v => v.id)
      }
      if (level === 2 || level === 3) {
        temList = ((toLineData.find(v => v.id === parentId) || {}).childrens || []).map(v => v.id)
      }
      return temList.indexOf(id) > 0
    },
    /** 下移显示判断 */
    getDownElShow(id, parentId, level) {
      const toLineData = this.common.toLine(this.treeData, 'childrens')
      let temList = []
      if (level === 1) {
        temList = toLineData.filter(v => v.level === 1).map(v => v.id)
      }
      if (level === 2 || level === 3) {
        temList = ((toLineData.find(v => v.id === parentId) || {}).childrens || []).map(v => v.id)
      }
      return temList.indexOf(id) !== temList.length - 1
    },
    /** 新增报价类目 */
    addTagCategory() {
      this.$refs.addTreeLevel.show({})
    },
    /** 新增报价类目成功 */
    addTagCategoryDone() {
      this.getTreeList()
    },
    /** 选中节点 */
    onSelect(selectedKeys) {
      this.selectKey = (selectedKeys.length > 0) ? selectedKeys[0] : undefined
      this.defaultSelectKeys = (selectedKeys.length > 0) ? selectedKeys : []
      this.rightTableData = this.defaultSelectKeys.length > 0 ? this.getRightTableData(this.treeData, this.defaultSelectKeys[0]) : []
      this.$emit('getTagList', this.rightTableData)
    },
    getRightTableData(data, currentKey) {
      let firstParentData = this.$utils.searchTree(data, item => item.id === currentKey, {children: 'childrens' })
      const parentIdList = this.finParentIdList(data, currentKey)
      const firstParentId = parentIdList.length > 0 ? parentIdList[0] : undefined
      let dataList = []
      if (firstParentId) {
        const parentTableList = data.filter(v => v.id === firstParentId)[0]['childrens']
        dataList = (parentTableList && parentTableList.length > 0)
          ? this.common.toLine(parentTableList, 'childrens')
          : []
      }
      return [...firstParentData, ...dataList]
    }
  }
}
</script>

<style scoped lang="less">
.tag-tree{
  position: relative;
  padding: 36px 0 10px;
  border: 1px solid #ccc;
  box-sizng: border-box;
  .tag-tree-add{
    position: absolute;
    width: 100%;
    height: 36px;
    left: 0;
    top: 0;
    button{
      width: 100%;
      height: 36px;
    }
  }
  .tag-tree-head{
    box-sizng: border-box;
    /deep/ .ant-spin{
      width: 100%;
      padding-top: 20px;
      .ant-spin-dot{
        margin: 0 auto;
      }
    }
  }
  .noting-tag{
    color: #999;
    text-align: center;
    margin-top: 30px;
  }
  /deep/ .ant-tree li .ant-tree-node-content-wrapper{
    width: calc(100% - 25px);
  }
  /deep/ .ant-tree li .tree-list{
    width: 100%;
    height: 24px;
    position: relative;
    .name{
      max-width: 125px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  /deep/ .ant-tree li .tree-list .operation-btns{
    width: 30px;
    position: absolute;
    right: 0;
    top: 2px;
    i{
      font-size: 20px;
    }
  }
}
</style>
